const CACHE = {
  REVALIDATE: 60,
} as const;

export default CACHE;
